import i18n from 'i18next';
import en from './locales/en.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import fi from './locales/fi.json';
import countryCodesEn from './locales/countryCodes/en.json';
import countryCodesSv from './locales/countryCodes/sv.json';
import countryCodesNo from './locales/countryCodes/no.json';
import countryCodesFi from './locales/countryCodes/fi.json';

i18n.addResourceBundle('en', 'registrations', { ...en, ...countryCodesEn.countries });
i18n.addResourceBundle('sv', 'registrations', { ...sv, ...countryCodesSv.countries });
i18n.addResourceBundle('no', 'registrations', { ...no, ...countryCodesNo.countries });
i18n.addResourceBundle('fi', 'registrations', { ...fi, ...countryCodesFi.countries });
